import React from 'react';
import queryString from "query-string";
import { FormattedHTMLMessage } from "react-intl";
import { NavLink, Route } from "react-router-dom";

const links = [
  { to: "home", exact: true, id: "pages:home:menuLabel" },
  { to: "company", id: "pages:company:menuLabel" },
  { to: "products", id: "pages:products:menuLabel" },
  { to: "engineering", id: "pages:services:menuLabel" },
  { to: "procurement", id: "pages:procurement:menuLabel" },
  { to: "projects", id: "pages:projects:menuLabel" },
  { to: "quality", id: "pages:quality:menuLabel" },
  { to: "news", id: "pages:news:menuLabel" },
  { to: "contacts", id: "pages:contacts:menuLabel" }
];
const MainMenu = React.createClass({
  getInitialState() {
    return {
      mobileMenu: false
    };
  },
  render() {
    const { location } = this.props;
    const locationId = location.pathname.split("/")[1];
    const query = queryString.parse(location.search || "?l=it");
    const languageID = query.l || "it";
    const menuLink = query.menu == "true";
    const route = location.pathname.split("/")[1];
    const { mobileMenu } = this.state;
    return (
      <div className="main-menu">
        <div className="main-menu-left">
          <div className="menu-logo-container">
            <NavLink
              to={`/home?l=${languageID}${
                locationId != "home" ? "&menu=true" : ""
              }`}
              onClick={e => this.setState({ mobileMenu: false })}
            >
              <div
                className="menu-logo-desktop"
                style={{ backgroundImage: 'url("images/logotypes/logo.png")' }}
              />
            </NavLink>
          </div>
          <a
            className={`menu-new-energy ${
              locationId == "new-energy" ? "active" : ""
            }`}
            href="/new-energy"
            target="_blank"
          >
            NEW ENERGY
          </a>
          <a
            className={`menu-new-energy ${
              locationId == "new-partnership" ? "active" : ""
            }`}
            href="/new-partnership"
            style={{ marginLeft: '15px' }}
            target="_blank"
          >
            PARTNERSHIP
          </a>
        </div>
        <div
          onClick={e => this.setState({ mobileMenu: !mobileMenu })}
          className="hamburger-menu-icon"
          style={{ backgroundImage: 'url("images/icons/menu.png")' }}
        />
        <div className="nav-container">
          <nav className="main-menu-sections">
            {!(locationId == "new-energy" || locationId == "new-partnership") &&
              links.map((link, i) => (
                <NavLink
                  key={i}
                  to={`/${link.to}?l=${languageID}${
                    locationId != link.to ? "&menu=true" : ""
                  }`}
                  exact={link.exact || false}
                >
                  <span
                    style={
                      route == link.to
                        ? { fontSize: "17px", fontWeight: "bold" }
                        : { fontSize: "15px" }
                    }
                  >
                    <FormattedHTMLMessage id={link.id} />
                  </span>
                </NavLink>
              ))}
          </nav>
          <nav className="main-menu-languages">
            {!(locationId == "new-partnership") &&   
            <span>
            <NavLink to={{ search: "l=it" }}>
              <FormattedHTMLMessage id="app:language:it" />
            </NavLink>           
            |
            </span>         
            }                          
             <NavLink to={{ search: "l=en" }}>               
              <FormattedHTMLMessage id="app:language:en" />
            </NavLink>            
            
            <Route
              path="/new-energy"
              render={() => (
                <NavLink
                  to={{ search: "l=ru" }}
                  style={{
                    position: "relative",
                    left: "-8px"
                  }}
                >
                  | <FormattedHTMLMessage id="app:language:ru" />
                </NavLink>
              )}
            />
          </nav>
        </div>
        {mobileMenu && (
          <ul
            className="mobile-menu-container"
            onClick={e => this.setState({ mobileMenu: false })}
          >
            <li>
              <a href="/new-energy" target="_blank">
                New Energy
              </a>
              <a href="/new-partnership" target="_blank">
                Partnership
              </a>
            </li>
            {!(locationId == "new-energy") &&
              links.map((link, i) => (
                <li key={i}>
                  <NavLink
                    to={`/${link.to}?l=${languageID}${
                      locationId != link.to ? "&menu=true" : ""
                    }`}
                    exact={link.exact || false}
                  >
                    <span
                      style={
                        route == link.to
                          ? { fontSize: "1.2em", fontWeight: "bold" }
                          : {}
                      }
                    >
                      <FormattedHTMLMessage id={link.id} />
                    </span>
                  </NavLink>
                </li>
              ))}
            <li className="mobile-menu-languages">
              <NavLink to={{ search: "l=it" }}>
                <FormattedHTMLMessage id="app:language:it" />
              </NavLink>
              <NavLink to={{ search: "l=en" }}>
                <FormattedHTMLMessage id="app:language:en" />
              </NavLink>
              <Route
                path="/new-energy"
                render={() => (
                  <NavLink to={{ search: "l=ru" }}>
                    <FormattedHTMLMessage id="app:language:ru" />
                  </NavLink>
                )}
              />
            </li>
          </ul>
        )}
      </div>
    );
  }
});

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.js